import { SgSkuQtyCellRendererComponent } from 'src/app/ag-grid-components/sg-sku-qty-cell-renderer/sg-sku-qty-cell-renderer.component';
import { Injectable, OnDestroy } from "@angular/core";
import { GridApi, GridOptions } from "@ag-grid-community/core";
import { HeaderService } from "src/app/components/header/header.service";
import { Subject, takeUntil } from "rxjs";
import { AmountInShipmentCellRendererComponent } from "../ag-grid-components/amount-in-shipment-cell-renderer/amount-in-shipment-cell-renderer.component";
import { BooleanCellRendererComponent } from "../ag-grid-components/boolean-cell-renderer/boolean-cell-renderer.component";
import { BooleanFilterComponent } from "../ag-grid-components/boolean-filter/boolean-filter.component";
import { BtnCellRendererComponent } from "../ag-grid-components/btn-cell-renderer/btn-cell-renderer.component";
import { BuyBoxCellRendererComponent } from "../ag-grid-components/buy-box-cell-renderer/buy-box-cell-renderer.component";
import { DateCellRendererComponent } from "../ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import {DeleteIconRendererComponent} from '../ag-grid-components/delete-icon-renderer/delete-icon-renderer.component';
import {DiscountPricePercentCellEditComponent} from '../ag-grid-components/discount-price-percent-cell-edit/discount-price-percent-cell-edit.component';
import { LoadingCellRendererComponent } from "../ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { MultiPriceCellRendererComponent } from "../ag-grid-components/multi-price-cell-renderer/multi-price-cell-renderer.component";
import { NoteCellRendererComponent } from "../ag-grid-components/note-cell-renderer/note-cell-renderer.component";
import { NumberAndTrendCellRendererComponent } from "../ag-grid-components/number-and-trend-cell-renderer/number-and-trend-cell-renderer.component";
import { OffersCellRendererComponent } from "../ag-grid-components/offers-cell-renderer/offers-cell-renderer.component";
import { PriceOverrideCellEditorComponent } from "../ag-grid-components/price-override-cell-editor/price-override-cell-editor.component";
import { PriceOverrideCellRendererComponent } from "../ag-grid-components/price-override-cell-renderer/price-override-cell-renderer.component";
import { RankCellRendererComponent } from "../ag-grid-components/rank-cell-renderer/rank-cell-renderer.component";
import { ReceivedQtyCellEditComponent } from "../ag-grid-components/received-qty-cell-edit/received-qty-cell-edit.component";
import { RepricingModelCellEditorComponent } from "../ag-grid-components/repricing-model-cell-editor/repricing-model-cell-editor.component";
import { RepricingModelCellRendererComponent } from "../ag-grid-components/repricing-model-cell-renderer/repricing-model-cell-renderer.component";
import {RoundCheckboxCellRendererComponent } from '../ag-grid-components/round-checkbox-cell-renderer/round-checkbox-cell-renderer.component';
import { SelectOptionCellRendererComponent } from "../ag-grid-components/select-option-cell-renderer/select-option-cell-renderer.component";
import { SelectPoCellRendererComponent } from "../ag-grid-components/select-po-cell-renderer/select-po-cell-renderer.component";
import { SimpleListCellRendererComponent } from "../ag-grid-components/simple-list-cell-renderer/simple-list-cell-renderer.component";
import { SinglePriceCellRendererComponent } from "../ag-grid-components/single-price-cell-renderer/single-price-cell-renderer.component";
import { SkuCellRendererComponent } from "../ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { SkuToolPanelComponent } from "../ag-grid-components/sku-tool-panel/sku-tool-panel.component";
import { StatusBarRendererComponent } from "../ag-grid-components/status-bar-renderer/status-bar-renderer.component";
import { ActionsComponent } from './../components/actions/actions.component';
import { MultiSkuToolPanelComponent } from '../ag-grid-components/multi-sku-tool-panel/multi-sku-tool-panel.component';
import { CasesCellRendererComponent } from '../ag-grid-components/cases-cell-renderer/cases-cell-renderer.component';
import { QtyWithTooltipCellRendererComponent } from '../ag-grid-components/qty-with-tooltip-cell-renderer/qty-with-tooltip-cell-renderer.component';
import { TagsColorCellrendererComponent } from '../ag-grid-components/tags-color-cellrenderer/tags-color-cellrenderer.component';
import { ToggleCellRendererComponent } from '../ag-grid-components/toggle-cell-renderer/toggle-cell-renderer.component';
import { GridReadyEvent } from '@ag-grid-community/core';


@Injectable({
  providedIn: "root",
})
export class SmartGridBaseConfigService implements OnDestroy {
  gridApi: GridApi;
  accounts;
  smartGridApi$: Subject<GridReadyEvent> = new Subject();
  cellFocusedIndexQty: number;
  private destroy$ = new Subject<void>();

  constructor(public headerService: HeaderService) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.accounts = e;
    });
  }
  components = {
    booleanCellRendererComponent: BooleanCellRendererComponent,
    buyBoxCellRendererComponent: BuyBoxCellRendererComponent,
    noteCellRendererComponent: NoteCellRendererComponent,
    rankCellRendererComponent: RankCellRendererComponent,
    skuCellRendererComponent: SkuCellRendererComponent,
    statusBarRendererComponent: StatusBarRendererComponent,
    dateCellRendererComponent: DateCellRendererComponent,
    priceOverrideCellRendererComponent: PriceOverrideCellRendererComponent,
    priceOverrideCellEditorComponent: PriceOverrideCellEditorComponent,
    repricingModelCellRendererComponent: RepricingModelCellRendererComponent,
    repricingModelCellEditorComponent: RepricingModelCellEditorComponent,
    loadingCellRenderer: LoadingCellRendererComponent,
    offersCellRendererComponent: OffersCellRendererComponent,
    amountInShipmentCellRendererComponent: AmountInShipmentCellRendererComponent,
    skuToolPanelComponent: SkuToolPanelComponent,
    multiPriceCellRendererComponent: MultiPriceCellRendererComponent,
    singlePriceCellRendererComponent: SinglePriceCellRendererComponent,
    numberAndTrendCellRendererComponent: NumberAndTrendCellRendererComponent,
    simpleListCellRendererComponent: SimpleListCellRendererComponent,
    booleanFilterComponent: BooleanFilterComponent,
    btnCellRenderer: BtnCellRendererComponent,
    discountPricePercentCellEdit: DiscountPricePercentCellEditComponent,
    selectOptionCellRendererComponent: SelectOptionCellRendererComponent,
    selectPoCellRendererComponent: SelectPoCellRendererComponent,
    deleteIconRenderer: DeleteIconRendererComponent,
    receivedQtyCellEdit: ReceivedQtyCellEditComponent,
    actionsComponent: ActionsComponent,
    roundCheckboxCellRenderer: RoundCheckboxCellRendererComponent,
    sgSkuQtyCellRendererComponent: SgSkuQtyCellRendererComponent,
    multiSkuToolPanelComponent: MultiSkuToolPanelComponent,
    casesCellRendere: CasesCellRendererComponent,
    qtyWithTooltipCellRendere: QtyWithTooltipCellRendererComponent,
    tagsColorCellrendererComponent:TagsColorCellrendererComponent,
    toggleCellRendereComponent: ToggleCellRendererComponent
  };

  gridOptions: GridOptions = {
    rowHeight: 30,
    domLayout: 'autoHeight',
    suppressMovableColumns: true,
    suppressRowDeselection: true,
    defaultColDef: {
      resizable: false,
      sortable:false,
    },
    components: this.components,
    loadingCellRenderer: "loadingCellRenderer",
    rowData: [],
    columnDefs: undefined,
    onGridReady: (e:GridReadyEvent) => {
      this.smartGridApi$.next(e);
    },
  };

  onCellKeyDown(e){
      const keyPressed = e.event.key;
      if (keyPressed === "Escape") {
        this.gridApi?.deselectAll();
      }  
      if(e.column && e.column.colId == 'qty'){
        if (keyPressed === "ArrowDown") {
          this.cellFocusedIndexQty = e.rowIndex + 1;
        }
        if (keyPressed === "ArrowUp") {
          this.cellFocusedIndexQty = e.rowIndex - 1;
        }
      }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
